import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material';
import {Provider as ReduxProvider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import {store} from './store';
import AppRouter from './router';

import './App.css';

const primaryColor = '#8FC600';
const errorColor = '#EC0000';

let theme = createTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: primaryColor,
      contrastText: '#FFFFFF',
    },
    // secondary: {
    // },
    error: {
      main: errorColor,
    },
    success: {
      main: primaryColor,
    },
    text: {
      main: '#212121',
    },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          // fontWeight: 'bold',
          // paddingTop: 0,
          paddingBottom: 1,
          margin: 0,
          fontSize: '1rem',
        },
        outlined: {
          backgroundColor: 'white',
          // color: primaryColor,
        },
        outlinedSuccess: {
          borderColor: '#58c65e',
          color: '#58c65e',
        },
        outlinedError: {
          color: errorColor,
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: '#9e9e9e',
          fontSize: 16,
          // fontWeight: 'bold',
          '&.Mui-completed,&.Mui-active': {
            fontWeight: 'bold',
            color: '#212121',
          },
        },
      },
    },
    //.css-1p3wkd2-MuiButtonBase-root-MuiListItemButton-root.Mui-selected
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#e0e0e0',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        // underlineAlways: {
        //   color: '#0F69C4',
        //   textDecorationColor: '#0F69C4',
        // },
        root: {
          color: '#0F69C4',
          textDecorationColor: '#0F69C4',
        },
      },
    },
  },
});
theme = responsiveFontSizes(theme);

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <ReduxProvider store={store}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ReduxProvider>
    </MuiThemeProvider>
  );
}

export default App;
